import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import Swiper from 'swiper/bundle'
// import 'swiper/swiper-bundle.css'

gsap.registerPlugin(ScrollTrigger)

export default class FaidSlide {
  constructor(wrapper, config) {
    // 変数宣言
    // ---------------------------------
    this.container = wrapper
    this.config = config
    this.endFn = this.config.endFn
    this.targetId = this.config.targetId || []
    this.list = gsap.utils.toArray('.faidSlide_item', wrapper)
    this.length = this.list.length
    this.navigation = this.config.navigation || false
    this.navContainer
    this.navList = []
    this.heights = []
    this.startY = []
    this.ids = []
    this.totalHeight = 0
    this.standardHeight = 1000

    // console.log(this.length)

    // // 初期の処理
    this.init()
  }

  async init() {
    // 初期の処理
    // ---------------------------------
    await this.setHeight()
    if (this.navigation) {
      this.createNav() //ナビゲーションのエレメント作成
      this.navList.forEach((elm, i) => {
        elm.addEventListener('click', () => this.scrollAnimation(this.ids[i]))
      })
    }
    await this.setScrollTrigger()

    // // ハッシュタグの検索
    // window.addEventListener('DOMContentLoaded', () => {
    //   setTimeout(() => {
    //     const hash = location.hash
    //     // location.hash = ''
    //     // console.log('hash', hash)
    //     if (hash) {
    //       const id = hash.replace('#', '')
    //       this.scrollAnimation(id)
    //     }
    //   }, 100)
    // })

    window.addEventListener('resize', () => this.refresh())
    if (window.innerWidth < 768) ScrollTrigger.disable()

    await this.endInit()
  }

  async endInit() {
    // console.log('[endInit]')
    if (this.endFn) await this.endFn()
  }

  async setHeight() {
    // console.log('[setHeight]')
    let total = parseFloat(gsap.getProperty(this.container, 'height', 'px'))
    this.standardHeight = total
    const clientRect = this.container.getBoundingClientRect()
    let y = window.scrollY + clientRect.y
    // let y = 0
    this.list.forEach((elm, i) => {
      this.ids[i] = elm.id
      const height = parseFloat(gsap.getProperty(elm, 'height', 'px'))
      this.startY[i] = y
      this.heights[i] = height

      total += height
      y += height
    })

    this.totalHeight = total

    // console.log('startY', this.startY)
  }

  async setScrollTrigger() {
    // console.log('[setScrollTrigger]')
    ScrollTrigger.config({ ignoreMobileResize: true })

    // 親の固定処理
    this.parentGsap = gsap.to(this.container, {
      scrollTrigger: {
        trigger: this.container,
        pin: true,
        anticipatePin: 1,
        invalidateOnRefresh: true,
        start: 'top top',
        end: () => this.totalHeight
        // markers: true
      }
    })

    // 子要素のアニメーション
    this.list.forEach((elm, i) => {
      const d = this.heights[i] / 100
      // this.times[i] = d
      gsap.fromTo(
        elm,
        {
          opacity: i !== 0 ? 0.0 : 1.0,
          pointerEvents: i !== 0 ? 'none' : 'auto'
        },
        {
          opacity: 1,
          pointerEvents: 'auto',
          duration: 0.3,
          ease: 'none',
          scrollTrigger: {
            trigger: elm,
            start: () => this.startY[i],
            end: () => `+=${this.standardHeight}`,
            toggleActions:
              i !== this.length - 1
                ? 'play reverse play reverse'
                : 'play complete play reverse',
            toggleClass: {
              targets: [elm, this.navList[i]],
              className: 'active'
            }
            // markers: true
          }
        }
      )
    })
  }

  scrollAnimation(id) {
    // console.log('[scrollAnimation]', id)
    if (!this.targetId.includes(id)) return
    const target = document.getElementById(id)
    const result = this.list.indexOf(target)
    let scrollTop = this.startY[result] + this.standardHeight * 0.5

    // console.log('scrollAnimation', id, scrollTop, this.parentGsap)

    window.scrollTo({
      top: scrollTop,
      left: 0,
      behavior: 'smooth'
    })
    // console.log('scrollAnimation', id, scrollTop, this.parentGsap)
  }

  createNav() {
    // console.log('[createNav]')
    // ナビゲーションの作成
    const navContainer = document.createElement('div')
    navContainer.classList.add('slide_nav-container')
    gsap.set(navContainer, {
      position: 'absolute',
      right: '2.5%',
      top: '50%',
      yPercent: -50
    })
    for (let i = 0; i < this.length; i++) {
      const childElm = document.createElement('div')
      childElm.classList.add('slide_nav-item')
      childElm.classList.add('mouse_stalker-link')

      this.navList[i] = childElm
      navContainer.appendChild(childElm)
    }

    this.container.appendChild(navContainer)
  }

  refresh() {
    // サイズ変更時の処理
    ScrollTrigger.disable() // scrollTrigger停止
    if (window.innerWidth >= 768) {
      // pcサイズ時は計算処理
      this.setHeight()
      if (this.navigation && this.navList.length === 0) {
        this.createNav()
        this.navList.forEach((elm, i) => {
          elm.addEventListener('click', () => this.scrollAnimation(this.ids[i]))
        })
      }
      ScrollTrigger.enable() // scrollTrigger起動
    }
  }
}
